export const multiline = (s) => s.replace(/[\s\n]+/g, ' ').trim();
